
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoadPlantPlanetState, LoadPlantPlanetStateSuccess, LoadPlantPlanetStateFail, PlantPlanetActionTypes } from './plant-planet.actions';
import { IPlantPlanet, LGEDataService } from 'src/commons';
import { catchError, from, map, of, switchMap } from 'rxjs';

@Injectable()
export class PlantPlanetEffects {
  loadPlantPlanetState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PlantPlanetActionTypes.LoadPlantPlanetState),
      map((action: LoadPlantPlanetState) => action.payload),
      switchMap((formId) => from(this.lgeService.formPPById(formId)).pipe(
        map((state: IPlantPlanet) => new LoadPlantPlanetStateSuccess(state)),
        catchError(error => of(new LoadPlantPlanetStateFail(error)))
      ))
    )
  )
  // : Observable<Action> = this.actions$
  //   .ofType(PlantPlanetActionTypes.LoadPlantPlanetState)
  //   .map((action: LoadPlantPlanetState) => action.payload)
  //   .switchMap((formId) =>
  //   // You can pull from offline state here or get data from a server via an api
  //   // An example of inserting data into offline state can be found in login.effects.ts
  //       Observable.fromPromise(this.lgeService.formPPById(formId))
  //       .map((state: IPlantPlanet) => new LoadPlantPlanetStateSuccess(state))
  //       .catch(error => Observable.of(new LoadPlantPlanetStateFail(error)))
  //   );
  constructor(
    private actions$: Actions,
    private lgeService: LGEDataService
  ) { }
}